import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { UiAccordion } from "../../../components/common/UiAccordion";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import {
    UiContentCol,
    UiContentWr,
} from "../../../components/common/UiPageElements";
import {
    UiCol,
    UiRowContainer,
} from "../../../components/grid-container/GridContainer";
import TermsImg from "../../../../../styles/img/custom/terms-img.png";
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";
import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds
} from "../../../../../_redux/_constants";

export const TermsConditionsQ3 = (props) => {
    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    const advisorTermsConditions = [
        {
            id: 1,
            title: "Programme Period",
            description: "July 1, 2024 to September 30, 2024",
        },
        {
            id: 2,
            title: "Participation Rules",
            description: (
                <>
                    <p>
                        Service Advisors must have passed their bronze
                        accreditation by the end of Q3 2024 to qualify for
                        campaign inclusion plus you must be registered on the RG
                        Équipe site within 30 days from the launch of the
                        campaign date.
                    </p>
                    <p>
                        The Promoter reserves the right to withdraw or amend the
                        details of the incentive in the event of unforeseen
                        circumstances outside its reasonable control.
                    </p>
                    <p>
                        If the Promoter has grounds to suspect any entrant or
                        third party of cheating, deception or fraudulent or
                        unsportsman-like conduct of any kind (including, without
                        limitation, manipulating the incentive or any entry) the
                        Promoter reserves the right (in its sole discretion) to
                        disqualify any Retailer or Service Advisor, entry, or
                        person it reasonably believes to be responsible for, or
                        associated with, such activity.
                    </p>
                </>
            ),
        },
        {
            id: 3,
            title: "Rules of Reward",
            description: (
                <>
                    <p>
                        The Reward cannot be transferred, refunded, or exchanged
                        for a cash alternative. The Promoter reserves the right
                        to substitute the Reward (or any part of it) for a
                        reward or rewards of equivalent or greater monetary
                        value if this is necessary.
                    </p>
                    <p>
                        Any other costs that are incurred that are incidental to
                        the fulfilment of the Reward are the sole responsibility
                        of the winner.
                    </p>
                </>
            ),
        },
        {
            id: 4,
            title: "Reward Taxation",
            description: (
                <p>
                    Based on the present level of legislation knowledge, awards
                    for this programme will attract both personal taxation and
                    National Insurance Contributions. Renault UK will settle
                    both the standard rate of personal tax and any NIC liability
                    on your behalf. Awards are only intended for the benefit of
                    Renault Retailer employees.
                </p>
            ),
        },
        {
            id: 5,
            title: "Dispute",
            description: (
                <>
                    <p>
                        In the event of any dispute the decision of the Promoter
                        will be considered final.
                    </p>

                    <p>Promoter: Renault UK Limited</p>
                </>
            ),
        },
    ];

    const termsConditions = [
        {
            id: 1,
            title: "Programme Period",
            description: "July 1, 2024 to September 30, 2024",
        },
        {
            id: 2,
            title: "Participation Rules",
            description: (
                <>
                    <p>
                        Service Advisors must have passed their bronze
                        accreditation by the end of Q3 2024 to qualify for
                        campaign inclusion plus you must be registered on the RG
                        Équipe site within 30 days from the launch of the
                        campaign date.
                    </p>
                    <p>
                        The Promoter reserves the right to withdraw or amend the
                        details of the incentive in the event of unforeseen
                        circumstances outside its reasonable control.
                    </p>
                    <p>
                        If the Promoter has grounds to suspect any entrant or
                        third party of cheating, deception or fraudulent or
                        unsportsman-like conduct of any kind (including, without
                        limitation, manipulating the incentive or any entry) the
                        Promoter reserves the right (in its sole discretion) to
                        disqualify any Retailer or Service Advisor, entry, or
                        person it reasonably believes to be responsible for, or
                        associated with, such activity.
                    </p>
                </>
            ),
        },
        {
            id: 3,
            title: "Rules of Reward",
            description: (
                <>
                    <p>
                        The Reward cannot be transferred, refunded, or exchanged
                        for a cash alternative. The Promoter reserves the right
                        to substitute the Reward (or any part of it) for a
                        reward or rewards of equivalent or greater monetary
                        value if this is necessary.
                    </p>
                    <p>
                        Any other costs that are incurred that are incidental to
                        the fulfilment of the Reward are the sole responsibility
                        of the winner.
                    </p>
                </>
            ),
        },
        {
            id: 4,
            title: "Reward Taxation",
            description: (
                <p>
                    Based on the present level of legislation knowledge, awards
                    for this programme will attract both personal taxation and
                    National Insurance Contributions. Renault UK will settle
                    both the standard rate of personal tax and any NIC liability
                    on your behalf. Awards are only intended for the benefit of
                    Renault Retailer employees.
                </p>
            ),
        },
        {
            id: 5,
            title: "Dispute",
            description: (
                <>
                    <p>
                        In the event of any dispute the decision of the Promoter
                        will be considered final.
                    </p>

                    <p>Promoter: Renault UK Limited</p>
                </>
            ),
        },
    ];

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <div className="sb-accordion-wrapper sb-terms-and-conditions">
                        <Accordion defaultActiveKey={"0"}>
                            <Accordion.Item eventKey="0" key="0">
                                <div className="d-md-flex">
                                    <UiCol lg="9">
                                        <UiContentCol>
                                            <div className="sb-first-accordion-header">
                                                <Accordion.Header>
                                                    <UiCardTitle title="Terms & Conditions" />{" "}
                                                    <span className="sb-accordion-wrapper__plus">
                                                        <PlusIcon />
                                                    </span>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body>
                                                <UiContentWr>
                                                    <UiRowContainer
                                                        fluid="fluid"
                                                        className="sb-terms-conditions-wrapper"
                                                    >
                                                        <UiCol lg="12">
                                                            <UiContentCol>
                                                                {auth
                                                                    ?.userProfileDetails
                                                                    .participantManager &&
                                                                auth
                                                                    ?.userProfileDetails
                                                                    .jobRole ==
                                                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                                                                auth
                                                                    ?.userProfileDetails
                                                                    .roleId ==
                                                                    participantTypeIds.PARTICIPANT ? (
                                                                    <UiAccordion
                                                                        items={
                                                                            advisorTermsConditions
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <UiAccordion
                                                                        items={
                                                                            termsConditions
                                                                        }
                                                                    />
                                                                )}
                                                            </UiContentCol>
                                                        </UiCol>
                                                    </UiRowContainer>
                                                </UiContentWr>
                                            </Accordion.Body>
                                        </UiContentCol>
                                    </UiCol>
                                    <UiCol lg="3" className="sb-pad-set-left">
                                        <UiContentWr>
                                            <UiRowContainer
                                                fluid="fluid"
                                                className="sb-terms-conditions-right-wrapper"
                                            >
                                                <UiCol lg="12">
                                                    <Accordion.Header>
                                                        <img src={TermsImg} />
                                                    </Accordion.Header>
                                                </UiCol>
                                            </UiRowContainer>
                                        </UiContentWr>
                                    </UiCol>
                                </div>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </UiRowContainer>
            </UiContentWr>
        </>
    );
};
